const NODE_ENV = process.env.REACT_APP_NODE_ENV;

export default NODE_ENV;
